import React from 'react';
import { useField } from 'formik';
import DateField from './DateField';

function SharpDateField({ ...props }) {
    const [field, meta, helpers] = useField(props);

    return (
        <DateField {...props} value={field.value} onChange={(value) => helpers.setValue(value)} onBlur={field.onBlur} helperText={meta.touched ? meta.error : ""} error={meta.touched ? Boolean(meta.error) : false} />
    );
};

export default SharpDateField;
